import React, { FC, memo } from 'react';
import Svg from './Svg';
import colors from '../../utils/colorConstants';

interface Props {
  className?: string;
  height?: string;
  strokeColor?: string;
  width?: string;
}

const PencilEdit: FC<Props> = ({
  className,
  height = '1.5rem',
  strokeColor = colors.lapel,
  width = '1.5rem',
}) => (
  <Svg className={className} height={height} title="edit" viewBox="0 0 24 24" width={width}>
    <path
      d="m9.7 17.8-3.5-3.5 8-8 3.5 3.5-8 8ZM5 19l.7-3.8 3.1 3.1L5 19ZM18.3 5.7c1 1 1 2.5 0 3.5l-3.5-3.5c1-1 2.6-1 3.5 0Zm.7 4.1A3.5 3.5 0 0 0 19 5a3.4 3.4 0 0 0-4.8 0l-9 9-.2.2-1 5.2c0 .3.2.6.6.6l5.1-1h.3l9-9.2Z"
      fill={strokeColor}
    />
  </Svg>
);

export default memo(PencilEdit);
